import { css } from 'styled-components';
import { backgroundToTextColor } from '@klv/shared/styles/themes/utils';

import type { ITypography } from '../types';

/* Flag */
const Headline = css<ITypography>`
  strong {
    font-weight: normal;

    ${({ flagColor, theme }) => (flagColor && flagColor !== 'transparent' ? css`
      background-color: ${theme.colors[flagColor]};
      color: ${backgroundToTextColor[flagColor]};
      display: inline-block;
      margin-left: -1rem;
      padding: 0.5rem 2rem 1rem 1rem;
      position: relative;

      &::after {
        aspect-ratio: 1;
        background-color: ${theme.colors[flagColor]};
        content: '';
        clip-path: polygon(31% 0, 0 0, 0 100%, 31% 100%, 2% 50%);
        display: block;
        height: 100%;
        left: calc(100% - 1px);
        position: absolute;
        top: 0;
        width: auto;

        @supports not (aspect-ratio: 1) {
          width: calc(100% / 4);
        }
      }`
    : '')}
  }
`;

export default Headline;
